<script setup lang="ts">
import { LINKS } from "@/constants/links";
</script>

<template>
    <footer id="bg-footer">
        <div class="container">
            <div class="col-md-11 mt-sm-2 mx-auto">
                <div class="clearfix" />
                <div class="row mb-4">
                    <div class="text-center middle">
                        <a
                            class="d-block d-sm-inline-block pb-2 py-sm-0 pe-md-2 link-underline
                            link-underline-opacity-0 link-underline-opacity-100-hover"
                            :href="LINKS.ACCESSIBILITY_LINK"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Accessibility</a>
                        <a
                            class="d-block d-sm-inline-block py-2 py-sm-0 px-sm-2 link-underline
                            link-underline-opacity-0 link-underline-opacity-100-hover"
                            :href="LINKS.ANNUITY_TERMS_AND_CONDITIONS"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Terms &amp; Conditions</a>
                        <a
                            class="d-block d-sm-inline-block py-2 py-sm-0 px-sm-2 link-underline
                            link-underline-opacity-0 link-underline-opacity-100-hover"
                            :href="LINKS.ANNUITY_PRIVACY_POLICY"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Privacy Notice</a>
                        <a
                            class="d-block d-sm-inline-block py-2 py-sm-0 px-sm-2 link-underline
                            link-underline-opacity-0 link-underline-opacity-100-hover"
                            :href="LINKS.OUR_SERVICES_LINK"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Our Services</a>
                        <a
                            class="d-block d-sm-inline-block py-2 py-sm-0 px-sm-2 link-underline
                            link-underline-opacity-0 link-underline-opacity-100-hover"
                            :href="LINKS.ANNUITY_COOKIE_POLICY"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Cookie Policy</a>
                        <a
                            class="d-block d-sm-inline-block py-2 py-sm-0 px-sm-2 link-underline
                            link-underline-opacity-0 link-underline-opacity-100-hover"
                            :href="LINKS.ANNUITY_MODERN_SLAVERY_STATEMENT"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Modern Slavery Statement</a>
                    </div>
                </div>
                <div class="row">
                    <div class="small">
                        <b>Quotations are provided by Annuity Ready on a non-advised basis. This means no advice is given or implied. You are solely responsible for deciding whether the policy is suitable for your needs.</b>
                        <p class="pt-2">
                            Annuity Ready is a trading style of Investment Discounts On Line Ltd and is part of the Legal &amp; General Group. Investment Discounts On Line Ltd is authorised and regulated by the Financial Conduct Authority, FCA Number 197451. Our operating address is: The Edge, Eden Business Park, Penrith, Cumbria, CA11 9FB. Telephone
                            <a
                                href="tel:08003265479"
                            >0800 326 5479</a>. Our registered address is: One Coleman Street, London, EC2R 5AA. UK Company Registration No. 04231834.
                        </p>
                        <p class="pt-2">
                            Copyright © {{ new Date().getFullYear() }} - Annuity Ready
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.ml-4 {
        margin-left: 1.5rem!important;
    }
</style>
